<template>
  <asc-card class="asc-mxrec-title--wrapper" flat>
    <template #title>
      <asc-required-label
        class="asc-mxrec-title__label"
        label="Maintenance Recommendation (Title)"
        :required="editable"
        uppercase
      />
    </template>
    <v-form ref="form" v-model="fields.valid">
      <v-row>
        <v-col cols="12" sm="8" md="8" lg="8">
          <asc-text-field-input
            v-model="fields.title"
            class="asc-mxrec-title__input"
            :readonly="!editable"
            :counter="editable"
            :max-length="titleLength"
            :rules="rules"
            update-on-blur
            @input="handleTitleInput"
          />
        </v-col>
        <v-col cols="12" sm="4" md="4" lg="4">
          <asc-text-field-input
            v-model="getDate"
            class="asc-mxrec-title__submittalDate"
            :label="getDateLabel"
            :disabled="editable || !isReadOnlyPermissionInvestigate"
            :readonly="!editable"
          />
        </v-col>
      </v-row>
    </v-form>
  </asc-card>
</template>

<script>
import AscCard from '@/components/atoms/AscCard'
import AscRequiredLabel from '@/components/atoms/AscRequiredLabel'
import AscTextFieldInput from '@/components/atoms/AscTextFieldInput'
import {
  AscMxRecPropsMixin,
  AscMxRecPermissionMixin,
} from '@/components/mixins'
import { getFormattedDate, daysDifference } from '@/utilities/dates'
import { COLLINS_PHM_TIER_3 } from '@/utilities/appConsts'

export default {
  name: 'AscMxRecTitleWrapper',

  components: {
    AscCard,
    AscTextFieldInput,
    AscRequiredLabel,
  },

  mixins: [AscMxRecPropsMixin, AscMxRecPermissionMixin],

  props: {
    fields: {
      type: Object,
      default: () => {},
    },
    titleLength: {
      type: Number,
      default: 0,
    },
    isPreSubmittal: {
      type: Boolean,
      default: false,
    },
    lockEnabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      rules: [
        v => (v && !!v.trim()) || 'This field is required for submission.',
      ],
    }
  },

  computed: {
    editable() {
      return (
        this.isEditPermissionInvestigate &&
        !this.isRecommendationTab &&
        this.airlineTierTypeId !== COLLINS_PHM_TIER_3 &&
        !this.lockEnabled
      )
    },
    getDateLabel() {
      return this.airlineTierTypeId === COLLINS_PHM_TIER_3
        ? 'Mx Rec Available Date'
        : 'Mx Rec Submittal Date'
    },
    getDate() {
      // Tier 3 or custom alert source then return created date as it wont have submitted date
      const date =
        this.airlineTierTypeId === COLLINS_PHM_TIER_3
          ? this.fields?.createdDate
          : !this.isPreSubmittal
          ? this.fields?.dateSubmitted
          : 'Not Submitted'

      const days =
        date && date !== 'Not Submitted'
          ? daysDifference(new Date(date), new Date())
          : null

      const daysAgo =
        date && date !== 'Not Submitted'
          ? days === 0
            ? 'Today'
            : days === 1
            ? '1 Day Ago'
            : `${days} Days Ago`
          : ''

      return date && date !== 'Not Submitted'
        ? `${getFormattedDate(date)} (${daysAgo})`
        : date === 'Not Submitted'
        ? date
        : 'N/A'
    },
  },

  methods: {
    handleTitleInput() {
      this.$emit('mxRecTitleInput', {
        valid: this.fields.valid,
        title: this.fields.title,
      })
    },
  },
}
</script>

<style lang="scss">
.asc-mxrec-title {
  &__label {
    .required {
      margin: 0;
    }
  }

  .asc-mxrec-title_input {
    &--disabled {
      cursor: not-allowed;
    }
  }
}
</style>
